<template>
  <div id="partnerContainer">
  </div>
</template>

<script>
export default {
  name: 'PartnerContainer'
}
</script>

<style>
  #partnerContainer {
    width: 100%;
    height: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PartnerContainer.vue